import React, { useState } from 'react';
import { UserPlusIcon } from '@heroicons/react/24/outline';
import { useAuthStore } from '../stores/authStore';
import { api } from '../services/api';
import toast from 'react-hot-toast';

const AddClientRole: React.FC = () => {
  const { user, updateUser } = useAuthStore();
  const [loading, setLoading] = useState(false);

  const isTrainer = user?.roles?.includes('TRAINER');
  const isAlreadyClient = user?.roles?.includes('CLIENT');

  const handleAddClientRole = async () => {
    if (!isTrainer || isAlreadyClient) return;

    try {
      setLoading(true);
      const response = await api.post('/users/add-role', { role: 'CLIENT' });
      
      // Update user in auth store
      updateUser(response.data.user);
      toast.success('Client role added successfully! You can now access client features for testing.');
    } catch (error: any) {
      console.error('Failed to add client role:', error);
      toast.error(error.response?.data?.error || 'Failed to add client role');
    } finally {
      setLoading(false);
    }
  };

  // Don't show if not a trainer or already has client role
  if (!isTrainer || isAlreadyClient) {
    return null;
  }

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
      <div className="flex items-start">
        <UserPlusIcon className="h-5 w-5 text-blue-600 mt-0.5 flex-shrink-0" />
        <div className="ml-3 flex-1">
          <h3 className="text-sm font-medium text-blue-800">Add Client Role</h3>
          <p className="text-sm text-blue-700 mt-1">
            As a trainer, you can add the client role to yourself for testing purposes or to create workouts and meal plans for yourself.
          </p>
          <button
            onClick={handleAddClientRole}
            disabled={loading}
            className="mt-3 inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'Adding...' : 'Add Client Role'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddClientRole;
